import { CheckCircle2, Users, Award, Clock } from 'lucide-react'

const highlights = [
  'Expert team with diverse skill sets',
  'Agile development methodology',
  '24/7 support and maintenance',
  'Transparent communication',
  'Results-driven approach',
  'Long-term partnerships'
]

const About = () => {
  return (
    <section id="about" className="about">
      <div className="container">
        <div className="about-grid">
          <div className="about-content">
            <span className="section-tag">About Us</span>
            <h2 className="section-title">
              We Are Passionate About Your Success
            </h2>
            <p className="about-text">
              With over a decade of experience, we have helped businesses of all sizes 
              transform their digital presence. Our team combines technical expertise 
              with creative thinking to deliver solutions that exceed expectations.
            </p>
            <p className="about-text">
              We believe in building lasting relationships with our clients, understanding 
              their unique challenges, and crafting solutions that drive real results.
            </p>
            <ul className="about-list">
              {highlights.map((item, index) => (
                <li key={index} className="about-item">
                  <CheckCircle2 size={20} className="check-icon" />
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </div>
          <div className="about-visual">
            <div className="feature-cards">
              <div className="feature-card">
                <Users size={32} />
                <span className="feature-number">50+</span>
                <span className="feature-label">Team Members</span>
              </div>
              <div className="feature-card">
                <Award size={32} />
                <span className="feature-number">25</span>
                <span className="feature-label">Industry Awards</span>
              </div>
              <div className="feature-card">
                <Clock size={32} />
                <span className="feature-number">24/7</span>
                <span className="feature-label">Support Available</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default About
